import React from "react";
import { NavButton } from "./NavSearchButton";
import { ChatIcon } from "@brandclub/common-ui";
import { useTheme } from "@mui/material";

const NavChatButton = ({
  onClick,
  id,
}: Pick<React.ComponentProps<typeof NavButton>, "onClick" | "id">) => {
  const theme = useTheme();
  return (
    <NavButton id={id} onClick={onClick}>
      <ChatIcon
        sx={{ fontSize: 25 }}
        backgroundColor={theme.palette.background.paper}
      />
    </NavButton>
  );
};

export default NavChatButton;
